import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function GetCustomQuestions(company) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}customquestion?fields=company&operator=eq&values=${company}`;

    const response = await axios.get(req, apiConfig.HEADERS_CONFIG,{
    });
    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
